export default __webpack_public_path__ + "static/media/gift.1b57a652.png";